import React from 'react';

const formatDate = (date, year, month, day) => {
  if (!date) return null;

  let options = {
    year: year,
    month: month,
    day: day,
  };
  let fmDate = new Date(date.toString()).toLocaleDateString('sv-SE', options);

  return fmDate.toUpperCase();
};

const FormatDateTime = ({ date, year, month, day }) => {
  return (
    <time dateTime={new Date(date).toISOString()} className="search-list__date">
      {formatDate(date, year, month, day)}
    </time>
  );
};
FormatDateTime.defaultProps = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

export default FormatDateTime;
